import { useQuery } from '@tanstack/react-query';
import { getWebAnalytics } from '../api/web-analytics';

export function useWebAnalytics(startDate?: string, endDate?: string) {
  return useQuery({
    queryKey: ['web-analytics', startDate, endDate],
    queryFn: () => getWebAnalytics(startDate, endDate),
    refetchInterval: 300_000,
  });
}
